// NotificationComponent.js
import React from 'react';
import { Notification } from 'baseui/notification';
import {useStyletron} from 'baseui';
import { Alert } from 'baseui/icon';

const EmptyListNotificationComponent = ({ message }) => {
  const [css, theme] = useStyletron();
  return (
    <Notification
      kind="warning"
      overrides={{
        Body: { style: { width: 'auto' } }
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Alert size="36px" color={theme.colors.warning}/>
        <span style={{ marginLeft: '10px', fontSize: "14px" }}>{message}</span>
      </div>
    </Notification>
  );
};

export default EmptyListNotificationComponent;
